<template>
	<v-dialog v-model="dialog" persistent max-width="400" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 secondary--text">Pencarian Data</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-3">
				<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-row>
						<v-col cols="12">
							<v-text-field hide-details label="Nama Stokis" color="primary" v-model="params.name.value"></v-text-field>
						</v-col>
						<v-col cols="12" class="mb-4">
							<v-text-field hide-details label="Kode Stokis" color="primary" v-model="params.code.value"></v-text-field>
						</v-col>
						<v-col cols="12" 	class="mb-4">
							<v-autocomplete
							label="Provinsi"
							no-data-text="Tidak ada data"
							color="primary"
							item-color="primary"
							hide-details="auto"
							:items="provinces"
							item-text="province_name"
							item-value="province_id"
							v-model="params.province.value"
							dense
							@change="changeProvince"></v-autocomplete>
						</v-col>
						<v-col cols="12" 	class="mb-4">
							<v-autocomplete
								label="Kabupaten / Kota"
								no-data-text="Pilih Provinsi Dahulu"
								color="primary"
								item-color="primary"
								hide-details="auto"
								:items="cities"
								item-text="city_name"
								item-value="city_id"
								v-model="params.city.value"
								dense></v-autocomplete>
						</v-col>
					</v-row>
				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded-xl text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cari">
						<v-icon small>mdi-magnify</v-icon>
						<span class="pl-2">Cari</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			searchDate: false,
			btnLoadingProses: false,
			params: {
				name: {
					type:'string',
					field:'stockist_name',
					comparison: '<>',
					value:''
				},
				code: {
					type:'string',
					field:'stockist_member_network_code',
					comparison: '<>',
					value:''
				},
				province: {
					type:'string',
					field:'stockist_province_id',
					comparison: '<>',
					value:''
				},
				city: {
					type:'string',
					field:'stockist_city_id',
					comparison: '<>',
					value:''
				},
			},
		}
	},
	computed:{
		...mapState('opsi', ['provinces', 'cities']),
	},
	props: {
	},
	methods :{
		...mapActions('opsi', ['getProvince', 'getCity']),

		changeProvince() {
			this.getCity({ province_id: this.params.province.value	})
			this.params.city.value = ''
		},
		modalShow() {
			this.dialog = true
			this.getProvince()
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.params.name.value = ''
			this.params.code.value = ''
			this.params.province.value = ''
			this.params.city.value = ''
		},
		async cari() {
			this.btnLoadingProses = await true
			await this.$emit('action', this.params)
		},
	}
};
</script>